import { Row, Col, Input, Spin, Tabs } from "antd";
import { RightOutlined, DownOutlined, LoadingOutlined } from "@ant-design/icons";
import Back from "../../../../assets/images/backIcon.svg";
import dayjs from "dayjs";

const { TabPane } = Tabs;

const CartHistoryView = ({
  colorVariable,
  setIsparkedBill,
  setIsInputFocused,
  setParkedBillSearchInput,
  setLayoutName,
  setCartHistoryData,
  setExpandedRowKey,
  setActiveTab,
  activeTab,
  searchInput,
  setSearchInput,
  getStatusForTab,
  fetchCartHistory,
  handleTabChange,
  loadingCart,
  cartHistoryData,
  expandedRowKey,
  toggleExpand,
  handleRetrieve,
  handleCancelSale,
}) => {
  return (
    <div
      style={{
        background: colorVariable ? colorVariable : "#f3f4f9",
        height: "100vh",
      }}
    >
      <Row style={{ padding: "1.5em 1.5em 0 1.5em", fontSize: "1vw" }}>
<Col
  span={6}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <img
    src={Back}
    id="sm-parked-bill-back"
    onClick={() => {
      setIsparkedBill(false);
      setIsInputFocused(false);
      setParkedBillSearchInput("");
      setLayoutName("default");
      setCartHistoryData([]);
      setExpandedRowKey(null);
      setActiveTab("pending");
    }}
    style={{
      width: "28px",
      height: "28px",
      cursor: "pointer",
      objectFit: "contain",
      flexShrink: 0,
    }}
  />

  <span
    style={{
      fontSize: "1.8rem",
      fontWeight: 500,
      color: "#0F0718",
      lineHeight: 1,
      fontFamily: "Inter, sans-serif",
      whiteSpace: "nowrap",
    }}
  >
    Cart History
  </span>
</Col>
        <Col
          span={18}
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
          }}
        >
          <Input
            placeholder="Search for customers"
            allowClear={false}
            style={{ width: "70%", borderRadius: "5px", border: "none" }}
            onPressEnter={() => {
              const status = getStatusForTab(activeTab);
              fetchCartHistory(status);
            }}
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
            value={searchInput}
          />
        </Col>
      </Row>

      <Row style={{ padding: "1em 1.5em" }}>
        <Tabs activeKey={activeTab} onChange={handleTabChange} style={{ width: "100%" }}>
          <TabPane tab="Pending" key="pending">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
              {cartHistoryData?.length === 0 && !loadingCart ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "3rem",
                    color: "#929098",
                    background: "#fff",
                    borderRadius: "12px",
                  }}
                >
                  No pending bills found
                </div>
              ) : (
                <CartHistoryTabContent
                  cartHistoryData={cartHistoryData}
                  expandedRowKey={expandedRowKey}
                  toggleExpand={toggleExpand}
                  statusLabel="Parked"
                  statusStyle={{ background: "#fff4e6", color: "#fa8c16" }}
                  handleRetrieve={handleRetrieve}
                  handleCancelSale={handleCancelSale}
                  showRetrieveButton={true}
                />
              )}
            </Spin>
          </TabPane>

          <TabPane tab="Processed" key="processed">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
              {cartHistoryData?.length === 0 && !loadingCart ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "3rem",
                    color: "#929098",
                    background: "#fff",
                    borderRadius: "12px",
                  }}
                >
                  No processed bills found
                </div>
              ) : (
                <CartHistoryTabContent
                  cartHistoryData={cartHistoryData}
                  expandedRowKey={expandedRowKey}
                  toggleExpand={toggleExpand}
                  statusLabel="Completed"
                  statusStyle={{ background: "#e6f7ff", color: "#1890ff" }}
                  handleRetrieve={null}
                  showRetrieveButton={false}
                />
              )}
            </Spin>
          </TabPane>

          <TabPane tab="Cancelled" key="cancelled">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} spinning={loadingCart}>
              {cartHistoryData?.length === 0 && !loadingCart ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "3rem",
                    color: "#929098",
                    background: "#fff",
                    borderRadius: "12px",
                  }}
                >
                  No cancelled bills found
                </div>
              ) : (
                <CartHistoryTabContent
                  cartHistoryData={cartHistoryData}
                  expandedRowKey={expandedRowKey}
                  toggleExpand={toggleExpand}
                  statusLabel="Cancelled"
                  statusStyle={{ background: "#fff1f0", color: "#ff4d4f" }}
                  handleRetrieve={null}
                  showRetrieveButton={false}
                />
              )}
            </Spin>
          </TabPane>
        </Tabs>
      </Row>
    </div>
  );
};

/**
 * Shared sub-component for rendering a single tab's content.
 * All three tabs (Pending, Processed, Cancelled) follow the exact same pattern
 * with only status label, style and retrieve button differing.
 */
const CartHistoryTabContent = ({ cartHistoryData, expandedRowKey, toggleExpand, statusLabel, statusStyle, handleRetrieve, handleCancelSale, showRetrieveButton }) => {
  return (
    <div>
      {/* Table Header */}
      <Row
        style={{
          background: "#fff",
          padding: "1rem 1.5rem",
          borderRadius: "12px 12px 0 0",
          fontWeight: 600,
          fontSize: "0.9rem",
          color: "#5D5A66",
          borderBottom: "1px solid #f0f0f0",
        }}
      >
        <Col span={5}>Parked Sale</Col>
        <Col span={5}>Document No</Col>
        <Col span={6}>Customer</Col>
        <Col span={3}>Qty</Col>
        <Col span={5}>Status</Col>
      </Row>

      {/* Table Rows */}
      {cartHistoryData?.map((record) => (
        <div key={record.key}>
          <Row
            style={{
              background: "#fff",
              padding: "1rem 1.5rem",
              borderBottom: "1px solid #f0f0f0",
              cursor: "pointer",
              alignItems: "center",
              fontSize: "0.95rem",
            }}
            onClick={() => toggleExpand(record.key)}
          >
            <Col span={5}>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                {expandedRowKey === record.key ? (
                  <DownOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                ) : (
                  <RightOutlined style={{ color: "#929098", fontSize: "0.8rem" }} />
                )}
                <span>{dayjs(record.request_date).format("YYYY-MM-DD HH:mm:ss")}</span>
              </div>
            </Col>
            <Col span={5}>
              <span style={{ fontWeight: 500 }}>{record.cart_no}</span>
            </Col>
            <Col span={6}>{record.cart_items?.customer?.name || "Cash & Carry"}</Col>
            <Col span={3}>{record.cart_items?.totalQty || 0}</Col>
            <Col span={5}>
              <span
                style={{
                  padding: "0.25rem 0.75rem",
                  borderRadius: "6px",
                  fontSize: "0.85rem",
                  fontWeight: 500,
                  ...statusStyle,
                }}
              >
                {statusLabel}
              </span>
            </Col>
          </Row>

          {/* Expanded Content */}
          {expandedRowKey === record.key && (
            <div
              style={{
                background: "#fafafa",
                padding: "1.5rem",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              {/* Items Table */}
              <div
                style={{
                  background: "#fff",
                  borderRadius: "8px",
                  padding: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <Row
                  style={{
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    color: "#5D5A66",
                    padding: "0.5rem 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <Col span={10}>Description</Col>
                  <Col span={4} style={{ textAlign: "center" }}>
                    Qty
                  </Col>
                  <Col span={5} style={{ textAlign: "right" }}>
                    Unit Price
                  </Col>
                  <Col span={5} style={{ textAlign: "right" }}>
                    Net Total
                  </Col>
                </Row>

                {record.cart_items?.items?.map((item, index) => (
                  <Row
                    key={item.lineId || index}
                    style={{
                      padding: "0.75rem 0",
                      borderBottom: index < record.cart_items.items.length - 1 ? "1px solid #f5f5f5" : "none",
                      fontSize: "0.9rem",
                    }}
                  >
                    <Col span={10}>
                      <div>{item.value}</div>
                      {item.name2 && <div style={{ fontSize: "0.8rem", color: "#929098", marginTop: "0.25rem" }}>{item.name2}</div>}
                    </Col>
                    <Col span={4} style={{ textAlign: "center" }}>
                      {item.weight}
                    </Col>
                    <Col span={5} style={{ textAlign: "right" }}>
                      {item.unitPrice?.toFixed(2)}
                    </Col>
                    <Col span={5} style={{ textAlign: "right", fontWeight: 500 }}>
                      {item.linenet?.toFixed(2)}
                    </Col>
                  </Row>
                ))}
              </div>

              {/* Summary Section */}
              <Row>
                <Col span={14}></Col>
                <Col span={10}>
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "1rem",
                    }}
                  >
                    <Row
                      style={{
                        marginBottom: "0.5rem",
                        fontSize: "0.9rem",
                      }}
                    >
                      <Col span={12}>Subtotal</Col>
                      <Col span={12} style={{ textAlign: "right" }}>
                        {record.cart_items?.subTotal?.toFixed(2)}
                      </Col>
                    </Row>
                    <Row
                      style={{
                        marginBottom: "0.75rem",
                        fontSize: "0.9rem",
                        paddingBottom: "0.75rem",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Col span={12}>Total tax</Col>
                      <Col span={12} style={{ textAlign: "right" }}>
                        {record.cart_items?.tax?.toFixed(2)}
                      </Col>
                    </Row>
                    <Row
                      style={{
                        fontWeight: 600,
                        fontSize: "1rem",
                      }}
                    >
                      <Col span={12}>SALE TOTAL</Col>
                      <Col span={12} style={{ textAlign: "right" }}>
                        {record.cart_items?.total?.toFixed(2)}
                      </Col>
                    </Row>
                  </div>

                  {/* Retrieve Button - Only in Pending Tab */}
                  {showRetrieveButton && record?.status !== "REQ" && (
                    <button
                      onClick={() => handleRetrieve(record)}
                      style={{
                        width: "100%",
                        marginTop: "1rem",
                        padding: "0.75rem",
                        background: "#1890ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "0.95rem",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      Retrieve sale
                    </button>
                  )}

                  {/* Cancel Sale Button - Only in Pending Tab */}
                  {showRetrieveButton && (
                    <button
                      onClick={() => handleCancelSale(record)}
                      style={{
                        width: "100%",
                        marginTop: "0.5rem",
                        padding: "0.75rem",
                        color: "#2f3856",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "0.95rem",
                        fontWeight: 500,
                        cursor: "pointer",
                      }}
                    >
                      Cancel sale
                    </button>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CartHistoryView;
